export default "__VITE_ASSET__CitHJbau__"